import styles from "./pet-grid.module.css";
import PetFilter from "../Filter";
import PetCard from "./components/PetCard";
import { TableLoader } from "../../../../components/LoaderC";
import { TablePagination } from "@mui/material";
import { useState } from "react";

const isWithin30Days = (createdAt) => {
    if (!createdAt) return false;
    const createdDate = new Date(createdAt);
    const today = new Date();
    const diffInDays = (today - createdDate) / (1000 * 60 * 60 * 24);
    return diffInDays <= 30;
  };

const PetGridView = ({
  contentLoading,
  allData,
  isGridView,
  handleView,
  filterData,
  setFilterData,
  setAddModalOpen,
  setDeletePetModalOpen,
  setSelectedId,
  setEditData,
  setEditModalOpen,
}) => {
  const [perPage, setPerPage] = useState(8);
  const [page, setPage] = useState(0);

  return (
    <div className={`${styles.BodyCon}`}>
      <div className={`${styles.mainCardDiv}`}>
        <div className={`${styles.mainCard}`}>
          <div className="control-pane">
            {contentLoading && (
              <div className="Loader TableLoader">
                <TableLoader />
              </div>
            )}

            {!contentLoading && (
              <div className={`${styles.Row}`}>
                <PetFilter
                  isGridView={isGridView}
                  handleView={handleView.bind(this)}
                  filterData={filterData}
                  setFilterData={setFilterData.bind(this)}
                  setPage={setPage.bind(this)}
                  setAddModalOpen={setAddModalOpen.bind(this)}
                />

                <div className={`${styles.NotesRow}`}>
                  {allData?.map((item, index) => {
                    const showBadge = isWithin30Days(item.created_at);
                    return perPage === -1 ||
                      (index >= page * perPage &&
                        index < page * perPage + perPage) ? (
                      <PetCard
                        item={item}
                        showBadge={showBadge}
                        setDeletePetModalOpen={setDeletePetModalOpen.bind(this)}
                        setSelectedId={setSelectedId.bind(this)}
                        setEditData={setEditData.bind(this)}
                        setEditModalOpen={setEditModalOpen.bind(this)}
                      />
                    ) : null;
                  })}

                  {allData.length > 0 && (
                    <div className="Pagination TablePaginationNew List">
                      <TablePagination
                        count={allData.length}
                        color="primary"
                        page={page}
                        rowsPerPage={perPage}
                        onPageChange={(e, v) => setPage(v)}
                        rowsPerPageOptions={[
                          { label: "4", value: 4 },
                          { label: "8", value: 8 },
                          { label: "16", value: 16 },
                          { label: "All", value: -1 },
                        ]}
                        onRowsPerPageChange={(e) => {
                          setPage(0);
                          setPerPage(e.target.value);
                        }}
                        labelRowsPerPage={"Pets per Page:"}
                      />
                    </div>
                  )}

                  {allData.length === 0 && (
                    <div className={`${styles.NoDataMain}`}>
                      <div className={`${styles.NoDataIMG}`}>
                        <img src="/static/img/pawprint.png" alt="No Data" />
                      </div>
                      <p className={`${styles.NoDataText}`}>Unfortunately!</p>
                      <p className={`${styles.NoDataTextSub}`}>
                        we couldn't find any pet at this time.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PetGridView;
